import FormInputLabel from './component.jsx'
export default FormInputLabel
